// extracted by mini-css-extract-plugin
export default {"description":"Description_description__I8ajw","error":"Description_error__G4sJ1"};